import { Divider, Text } from '@bitrise/bitkit';
import LinkItem from './LinkItem';

const HelpDrawer = () => {
  return (
    <>
      <LinkItem iconName="Deployment" href="/getting-started" marginTop="8">
        Getting started
      </LinkItem>
      <LinkItem iconName="Support" isExternal href="https://support.bitrise.io/hc/en-us" title="Support center">
        Support Center
      </LinkItem>
      <Divider marginY="24" />
      <Text fontWeight="bold" size="1" textTransform="uppercase" color="neutral.60" paddingX="24" marginBottom="16">
        Learn more
      </Text>
      <LinkItem iconName="Doc" isExternal href="https://devcenter.bitrise.io" title="Answers to your questions">
        Documentation
      </LinkItem>
      <LinkItem
        iconName="Flag"
        isExternal
        href="https://bitrise.io/roadmap"
        title="Explore and upvote upcoming features"
      >
        Roadmap
      </LinkItem>
      <LinkItem iconName="Chat" isExternal href="https://discuss.bitrise.io/" title="Ask your fellow developers">
        Community forum
      </LinkItem>
      <LinkItem iconName="ChatMessage" isExternal href="https://bitrise.io/blog/categories/product-updates">
        News and updates
      </LinkItem>
      <Divider marginY="24" />
      <Text fontWeight="bold" size="1" textTransform="uppercase" color="neutral.60" paddingX="24" marginBottom="16">
        Resources
      </Text>
      <LinkItem iconName="Steps" isExternal href="https://bitrise.io/integrations/steps">
        Step library
      </LinkItem>
      <LinkItem iconName="Workflow" isExternal href="https://github.com/bitrise-io/workflow-recipes">
        Workflow Recipes
      </LinkItem>
    </>
  );
};

export default HelpDrawer;
